import wx from 'weixin-js-sdk';
import {
    fetchJsApiConfig,
} from '@/api/getJsApiConfig';
export function wxShare(oShareInfo) {
    fetchJsApiConfig({
        js_api_list: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
        ],
        url: window.location.href,
    }).then((response) => {
        if (response.data.code == 1) {
            const oData = response.data.data;
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: oData.appId, // 必填，公众号的唯一标识
                timestamp: oData.timestamp, // 必填，生成签名的时间戳
                nonceStr: oData.nonceStr, // 必填，生成签名的随机串
                signature: oData.signature, // 必填，签名
                jsApiList: oData.jsApiList, // 必填，需要使用的JS接口列表
            });
            const oDefaultShareInfo = {
                title: '萌派宠物领养送养',
                desc: '宠物免费领养、送养、寻宠启示、寻主启示',
                imgUrl: 'https://petadopt.oss-cn-beijing.aliyuncs.com/uploads/petLogo.png',
                link: oData.url,
                success: () => {
                    // 设置成功
                },
            };
            wx.ready(function() { //需在用户可能点击分享按钮前就先调用
                wx.updateAppMessageShareData(Object.assign(oDefaultShareInfo, oShareInfo) || oDefaultShareInfo);
                wx.updateTimelineShareData(Object.assign(oDefaultShareInfo, oShareInfo) || oDefaultShareInfo);
            });
        }
    }).catch((err) => {
        console.log(err);
    });
};